import { render, staticRenderFns } from "./Chart.vue?vue&type=template&id=673676c4&"
import script from "./Chart.vue?vue&type=script&lang=js&"
export * from "./Chart.vue?vue&type=script&lang=js&"
import style0 from "./Chart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src469726766/src/admin-panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('673676c4')) {
      api.createRecord('673676c4', component.options)
    } else {
      api.reload('673676c4', component.options)
    }
    module.hot.accept("./Chart.vue?vue&type=template&id=673676c4&", function () {
      api.rerender('673676c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/plugins/Chart/components/Chart.vue"
export default component.exports